import React, { Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Button } from 'loyal-react'

const ConfirmationBox = ({ isLoading, location: { search } }) => {
  return (
    <Fragment>
      <div id='box-login' className={`box-login box-activate row pb-4`}>
        <div className='col-12 col-md-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-12'>
              <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>
                { process.env.RAZZLE_MESSAGE_CONFIRMATIONBOX_TITLE || 'Confirmação realizada com sucesso.'}
              </h1>
              <h2 className='h1 login-title txt-title-3 color-brand-1 txt-font-body mb-1'>
                { process.env.RAZZLE_MESSAGE_CONFIRMATIONBOX_SUBTITLE || 'Seu acesso foi confirmado e você já pode resgatar seus prêmios.'}
              </h2>
            </div>
          </div>
          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            {isLoading ? (
              <Button
                id='btnContinue'
                className='btn btn-sm btn-featured d-block txt-uppercase txt-circular-black'
                loading='true'
                type='button'
                text='Continuar'
              />
            ) : (
              <a
                href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/auth/login`}
                className='btn btn-sm btn-featured d-block txt-uppercase txt-circular-black'
              >
                { process.env.RAZZLE_MESSAGE_CONFIRMATIONBOX_LINK_LOGIN || 'Quero fazer login agora'}
              </a>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

ConfirmationBox.propTypes = {}

export default withRouter(ConfirmationBox)
